import * as React from 'react';

const SvgSuccessCircle = (props) => (
  <svg
    width={64}
    height={64}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M32 5.333C17.307 5.333 5.333 17.307 5.333 32c0 14.693 11.974 26.667 26.667 26.667 14.693 0 26.667-11.974 26.667-26.667C58.667 17.307 46.693 5.333 32 5.333Zm12.747 20.534-15.12 15.12a1.998 1.998 0 0 1-2.827 0l-7.547-7.547a2.012 2.012 0 0 1 0-2.827 2.012 2.012 0 0 1 2.827 0l6.133 6.134L41.92 23.04a2.012 2.012 0 0 1 2.827 0c.773.773.773 2.027 0 2.827Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgSuccessCircle;
